import { render, staticRenderFns } from "./ProtocoloCard.vue?vue&type=template&id=74944b33&scoped=true&"
import script from "./ProtocoloCard.vue?vue&type=script&lang=js&"
export * from "./ProtocoloCard.vue?vue&type=script&lang=js&"
import style0 from "./ProtocoloCard.vue?vue&type=style&index=0&id=74944b33&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74944b33",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
